import { render } from "./LabsLogo.vue?vue&type=template&id=460266a7&scoped=true"
import script from "./LabsLogo.vue?vue&type=script&lang=js"
export * from "./LabsLogo.vue?vue&type=script&lang=js"

import "./LabsLogo.vue?vue&type=style&index=0&id=460266a7&scoped=true&lang=css"

import exportComponent from "/workspace/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460266a7"]])

export default __exports__